<template>
	<PageTemplate>
		<template slot="title">
			Cryo-EM
		</template>
		<template slot="content">
			<v-layout>
				<v-flex xs12>
					<h2>Our laboratory has state of the art instruments</h2>
					<p>
					The Sauer Structural Biology Laboratory is the state-of-the-art cryo-EM facility. The SSBL
					houses both an FEI Titan Krios equipped with a Gatan K2 Summit direct electron detector and
					an FEI Talos also equipped with a Gatan K2 Summit direct electron detector. Both of these
					instruments are capable of imaging macromolecular machines at atomic or near atomic
					resolution. The facility also contains all of the accessory equipment required for high-resolution
					structure determination. The facility is staffed by a Ph.D. level manager, who has many years of
					experience with electron microscopy.
					</p>
				</v-flex>
			</v-layout>
			<v-layout>
				<v-flex xs12>
					<h2>FEI Titan Krios</h2>
					<img class="img-right" src="img/cryoem/fei_titan_krios.png" alt="Titan Krios">
					<p>
					The Titan Krios is a dedicated cryogenic electron microscope for life science imaging of cellular and macromolecular assemblies.
					It possesses a highly stable cryogenic environment suitable for automated and semi-automated data acquisition. Applications include 2D electron crystallography, single particle imaging, and tomographic imaging. It has a proven performance at obtaining images that preserve near atomic resolution detail in biological material in combination with second-generation direct electron detectors. The Krios is also equipped with FEI Volta phase plate technology that provides increased contrast to biological material embedded in vitreous ice.
					<br>
					<br>
						<a href="https://www.fei.com/products/tem/titan/" target="blank"><v-icon>open_in_new</v-icon> www.fei.com/products/tem/titan</a>
					</p>
				</v-flex>
			</v-layout>
			<v-layout>
				<v-flex xs12>
					<h2>FEI Glacios</h2>
					<img class="img-right" src="img/cryoem/Glacios_TEM_product_465x465.jpg-650.jpg" alt="Glacios">
					<p>
					<br>
The new Glacios features 200 kV XFEG optics, the industry-leading Autoloader (cryogenic sample manipulation robot) and the same innovative automation for ease of use as on the Krios G3i Cryo-TEM. The Glacios Cryo-TEM bundles all this into a small footprint that simplifies installation. The designed-in connectivity ensures a robust and contamination-free pathway throughout the entire workflow, from sample preparation and optimization to image acquisition and data processing. The Glacios Cryo-TEM is configured with a Falcon IV  Direct Electron Detector and a Ceta-D for micro-electron difraction.

					<br>
						<a href="https://www.thermofisher.com/order/catalog/product/GLACIOSTEM" target="blank"><v-icon>open_in_new</v-icon> www.thermofisher.com/order/catalog/product/GLACIOSTEM</a>
					</p>
				</v-flex>
			</v-layout>
			<v-layout>
				<v-flex xs12>
					<h2>FEI Vitrobot Mark IV</h2>
					<img class="img-right" src="img/cryoem/fei_vitrobot_mark_iv.png" alt="Vitrobot">
					<p>
					Vitrobot completely automates the vitrification process to provide fast, easy, reproducible sample preparation - the first step in obtaining high quality images and repeatable experimental results.
					<br>
					As a part of our Cryo-TEM workflow, researchers create high-quality vitrified samples for single particle analysis or cryo-tomography research applications. Vitrobot offers fully automated vitrification, fast and easy. It performs the cryo-fixation process at constant physical and mechanical conditions like temperature, relative humidity, blotting conditions and freezing velocity. This ensures high quality cryo-fixation results and a high sample preparation throughput prior to cryo-TEM observation. The Vitrobot's controlled environmental technology prevents cooling and concentration of artifacts that are inevitable in other freezing protocols. The transfer from the vitrification medium into the liquid nitrogen atmosphere has been automated,  ensuring consistent sample quality at high sample throughput. 
					<br>
					<br>
						<a href="https://www.fei.com/products/vitrobot-for-life-sciences/" target="blank"><v-icon>open_in_new</v-icon> www.fei.com/products/vitrobot-for-life-sciences </a>
					</p>
				</v-flex>
			</v-layout>
			<v-layout>
				<v-flex xs12>
					<v-container grid-list-xl fluid pr-2>
						<v-layout wrap justify-space-between align-center align-content-center style="border-top: 1px solid #cccccc; border-bottom: 1px solid #cccccc;">
							<v-flex xs6 sm3 class="text-xs-center">
								<img class="img-line" src="img/cryoem/gatan_626.jpeg">
								<span>
								Gatan 626 Dry Pumping Station
								</span>
							</v-flex>
							<v-flex xs6 sm3 class="text-xs-center">
								<img class="img-line" src="img/cryoem/gatan_k2.png">
								<span>
								Gatan K2 Summit Direct Electron Detector
								</span>
							</v-flex>
							<v-flex xs6 sm3 class="text-xs-center">
								<img class="img-line" src="img/cryoem/gatan_solarus.png">
								<span>
								Gatan Solarus Plasma Cleaner
								</span>
							</v-flex>
						</v-layout>
					</v-container>
				</v-flex>
			</v-layout>
		</template>
	</PageTemplate>
</template>

<script>
import PageTemplate from './PageTemplate'
export default {
  name: 'cryoem',
  data () {
    return {
      
    }
  },
  components:{
	PageTemplate
  }
}
</script>

<style scoped>
.img-right{
	max-width:300px;
	width:38%;
	height:auto;
	border: 1px solid #cccccc;
	padding:5px;
	float:right;
	margin-left:20px;
}
.img-line{
	width:100%;
	height:auto;
	display:block;
	max-width:230px;
}
p{
	padding-left:15px;
	text-align:justify;
}
</style>



// WEBPACK FOOTER //
// src/components/CryoEM.vue